// extracted by mini-css-extract-plugin
export default {"inputContainer":"Notice_inputContainer__Sn+4Z","inputForm":"Notice_inputForm__XbSVL","inputText":"Notice_inputText__F8HXV","submitButton":"Notice_submitButton__Opxe+"};